import register from '@kpsys/angularjs-register';
import {GlobalSearchService} from './global-search.service';
import {KpGlobalSearchInputPresenter} from 'shared/global-search/kp-global-search-input.presenter';

/**
 * @ngdoc module
 * @name portaro.shared.global-search
 * @module portaro.shared.global-search
 */

export default register('portaro.shared.global-search')
    .service(GlobalSearchService.serviceName, GlobalSearchService)
    .service(KpGlobalSearchInputPresenter.presenterName, KpGlobalSearchInputPresenter)
    .name();